import validate from "/app/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.13.10_@upstash+redis@1.34.5_db0@0.3.1_drizzl_gqtahqqainxzullhzdxe35kx6q/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.13.10_@upstash+redis@1.34.5_db0@0.3.1_drizzl_gqtahqqainxzullhzdxe35kx6q/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts"),
  otp: () => import("/app/middleware/otp.ts")
}